import React from "react";
import { format } from "date-fns";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";

import Typography from "@mui/material/Typography";
import { ResponseTime } from "../../types/types";

import styles from "./charts.module.css";

const mapToResponseChartData = (location: string, data: ResponseTime) => {
  const result: Array<any> = [];

  for (let i = 0; i < data.values.length; i++) {
    const date = data.dates[i];
    const value = data.values[i];
    const item: any = {};
    item["date"] = date;
    item[location] = Number(value);
    result.push(item);
  }
  return result;
};
type ResponseTimeChartProps = {
  location: string;
  data: ResponseTime;
};
const ResponseTimeChart = (props: ResponseTimeChartProps) => {
  const { data: responseTime, location } = props;

  const data = mapToResponseChartData(location, responseTime);

  //sort data by date
  const data2 = [...data].sort((a, b) => {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  });

  if (data2.length === 0) {
    return <></>;
  }
  return (
    <>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        Reporter Response Time
      </Typography>
      <ResponsiveContainer width={"80%"} height={300}>
        <LineChart
          width={500}
          height={300}
          data={data2.slice(0, 30)}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tickFormatter={(date) => format(date, "hh:mm:ss")}
          />
          <YAxis>
            <Label
              value={"Response Time (ms)"}
              position="left"
              angle={-90}
              style={{ textAnchor: "middle" }}
            />
          </YAxis>
          <Tooltip content={<CustomTooltip />} />
          {/* <Tooltip /> */}
          <Line
            dataKey={location}
            type="monotone"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        <Typography variant="caption" display="block" gutterBottom>
          <p className={styles.tooltip} style={{ textAlign: "center" }}>
            Response Time: <strong>{`${payload[0].value} ms`}</strong>
          </p>
        </Typography>
      </div>
    );
  }

  return null;
};

export default ResponseTimeChart;
